import ExcelJS from "exceljs";

// Exporta tablas HTML tal como se ven en pantalla (colores, negritas, combinaciones y formato numérico).
const NUM = /^(-?)\$?(-?)([\d,]+(?:\.\d+)?)(%?)$/;

function argb(css) {
  const m = css && css.match(/rgba?\(([^)]+)\)/);
  if (!m) return null;
  const [r, g, b, a = 1] = m[1].split(/[\s,/]+/).filter(Boolean).map(Number);
  if (a === 0) return null;
  const mix = (c) => Math.round(c * a + 255 * (1 - a));
  return "FF" + [mix(r), mix(g), mix(b)].map((c) => c.toString(16).padStart(2, "0")).join("").toUpperCase();
}

function texto(cell) {
  if (cell.querySelector("table")) return "";
  const ctrl = cell.querySelector("input:not([type=hidden]):not([type=range]), select, textarea");
  if (ctrl) return ctrl.value;
  return (cell.innerText || "").replace(/\s*\n+\s*/g, " ").trim();
}

function valor(t) {
  const s = t.replace(/\s/g, "");
  const m = s.match(NUM);
  if (!m || !/\d/.test(m[3])) return { v: t };
  const n = Number(m[3].replace(/,/g, "")) * (m[1] || m[2] ? -1 : 1);
  const dec = (m[3].split(".")[1] || "").length;
  const d = dec ? "." + "0".repeat(dec) : "";
  if (m[4]) return { v: n / 100, fmt: `0${d}%` };
  if (s.includes("$")) return { v: n, fmt: `"$"#,##0${d};-"$"#,##0${d}` };
  return { v: n, fmt: `#,##0${d}` };
}

function fondo(el, stop) {
  for (let e = el; e && e !== stop; e = e.parentElement) {
    const c = argb(getComputedStyle(e).backgroundColor);
    if (c) return c;
  }
  return null;
}

function tablaAHoja(ws, table, startRow, widths) {
  const occ = new Set();
  let r = startRow;
  const rows = Array.from(table.rows).filter((tr) => tr.offsetParent !== null || tr.getClientRects().length);
  rows.forEach((tr) => {
    let c = 1;
    const h = tr.getBoundingClientRect().height;
    Array.from(tr.cells).forEach((cell) => {
      while (occ.has(`${r}:${c}`)) c++;
      const cs = Math.max(1, cell.colSpan || 1), rs = Math.max(1, cell.rowSpan || 1);
      for (let i = 0; i < rs; i++) for (let j = 0; j < cs; j++) occ.add(`${r + i}:${c + j}`);
      const t = texto(cell);
      const { v, fmt } = valor(t);
      const xc = ws.getCell(r, c);
      xc.value = t === "" ? null : v;
      if (fmt) xc.numFmt = fmt;
      const st = getComputedStyle(cell);
      const fg = argb(st.color);
      xc.font = { name: "Calibri", size: cell.tagName === "TH" ? 10 : 10.5, bold: Number(st.fontWeight) >= 600, italic: st.fontStyle === "italic", color: fg ? { argb: fg } : undefined };
      const bg = fondo(cell, table.parentElement);
      if (bg && bg !== "FFFFFFFF") xc.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bg } };
      const al = st.textAlign === "right" || st.textAlign === "end" ? "right" : st.textAlign === "center" ? "center" : "left";
      xc.alignment = { horizontal: fmt && al === "left" ? "right" : al, vertical: "middle", wrapText: cell.tagName === "TH" };
      xc.border = { bottom: { style: "thin", color: { argb: "FFE2E8F0" } } };
      if (cs > 1 || rs > 1) ws.mergeCells(r, c, r + rs - 1, c + cs - 1);
      if (cs === 1) widths[c] = Math.max(widths[c] || 8, Math.min(48, cell.getBoundingClientRect().width / 7));
      c += cs;
    });
    if (h > 34) ws.getRow(r).height = Math.min(60, h * 0.75);
    r++;
  });
  return r;
}

export async function exportarExcel(fileName, titulo, hojas) {
  const wb = new ExcelJS.Workbook();
  wb.creator = "ZAE Ejecutivo";
  const usados = new Set();
  const html = document.documentElement;
  const oscuro = html.classList.contains("theme-dark");
  if (oscuro) html.classList.replace("theme-dark", "theme-light");
  try {
  hojas.forEach(({ name, el }) => {
    if (!el) return;
    let n = name.replace(/[\\/?*[\]:]/g, " ").slice(0, 31) || "Hoja";
    for (let i = 2; usados.has(n); i++) n = `${name.slice(0, 28)} ${i}`;
    usados.add(n);
    const ws = wb.addWorksheet(n, { views: [{ showGridLines: false }] });
    ws.getCell(1, 1).value = name;
    ws.getCell(1, 1).font = { name: "Calibri", size: 14, bold: true, color: { argb: "FF142B4C" } };
    ws.getCell(2, 1).value = titulo;
    ws.getCell(2, 1).font = { name: "Calibri", size: 10, italic: true, color: { argb: "FF5B6778" } };
    const widths = {};
    let r = 4;
    const tablas = el.tagName === "TABLE" ? [el] : Array.from(el.querySelectorAll("table"));
    if (!tablas.length) ws.getCell(r, 1).value = (el.innerText || "Sin información").trim();
    tablas.forEach((t) => { r = tablaAHoja(ws, t, r, widths) + 1; });
    Object.entries(widths).forEach(([c, w]) => { ws.getColumn(Number(c)).width = Math.round(w + 2); });
  });
  } finally {
    if (oscuro) html.classList.replace("theme-light", "theme-dark");
  }
  const buf = await wb.xlsx.writeBuffer();
  const url = URL.createObjectURL(new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${fileName.replace(/[\\/:*?"<>| ]+/g, "_")}.xlsx`;
  a.click();
  URL.revokeObjectURL(url);
}
